import axios from 'axios';
import { toast } from "react-toastify";
import { loadUser } from './authActions';

const PROXY = process.env.REACT_APP_URL + "api/";

export const watchList = (data) => async (dispatch) => {
    try {
        const res = await axios.post(`${PROXY}user/property/criteria`, data);
        
        dispatch(loadUser());
        return res;
    } catch (err) {
        toast.error(err?.response?.data?.message)
    }
}

export const watchListDetail = (page, limit) => async (dispatch) => {
    try {
        const res = await axios.get(`${PROXY}user/property/criteria?page=${page}&limit=${limit}`);
        // toast.success(res?.data?.message);
        return res;
    } catch (err) {
        console.log(err)
    }
}
